const keys = Object.keys;

class Indexer {
    // TODO: allow delete
    nameToParameters = {};
    tagToParameters = {};

    constructor() {}

    newParameter(name, tags, parameter) {
        // we are storing
        if (!this.nameToParameters[name]) {
            this.nameToParameters[name]=[];
        }
        this.nameToParameters[name].push(parameter);
        if (tags) {
            tags.forEach(tag => {
                if (!this.tagToParameters[tag]) {
                    this.tagToParameters[tag] = {};
                }
                this.tagToParameters[tag].push(parameter);
            });
        }
    }

    deleteParameter(parameter) {
        for (let name in this.nameToParameters) {
            if (this.nameToParameters[name].includes(parameter)) {
                this.nameToParameters[name] = this.nameToParameters[name].filter(
                    p => p !== parameter);
                break;
            }
        }

        for (let name in this.tagToParameters) {
            if (this.tagToParameters[name].includes(parameter)) {
                this.tagToParameters[name] = this.tagToParameters[name].filter(
                    p => p !== parameter);
                break;
            }
        }
    }

    search(name) {
        // we are searching
        let nameMatches = keys(this.nameToParameters)
            .filter(x => x.toLowerCase().includes(name.toLowerCase()))
                .flatMap(
                    x => this.nameToParameters[x]);
        let tagMatches = keys(this.tagToParameters)
            .filter(x => x.toLowerCase().includes(name.toLowerCase()))
            .flatMap(
                x => this.tagToParameters[x]);
        return [... nameMatches, ...tagMatches];
    }

    getAllParameters() {
        return Object.values(this.nameToParameters).flatMap(x => x);
    }
};

export const index = new Indexer();
window.parameterIndex = index;

